import z from "zod";

import { phoneZodField } from "@/schemas/shared/phone-field-schema";

export const familyContactEditFormSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
  cellPhone: phoneZodField,
  homePhone: z.string().optional().or(z.literal("")),
  address: z.string().min(3, "Address is required"),
});

export type FamilyContactEditFormSchemaType = z.infer<
  typeof familyContactEditFormSchema
>;
